import _React, { FC } from 'react';
import * as _ReactRouterDom from 'react-router-dom';
import Loading from './loading';
import { tangramParser, getLingoParser, initComponents } from '../parser';
import { lcdpMapping } from '../parser';
import { Env } from '../enum';

import type { Language } from '@tangram/shared';
import type { RouteComponentProps } from 'react-router-dom';

function setLcdpId(id: string, env: Env) {
  if (typeof (window as any).globalLcdpStore === 'object') {
    (window as any).globalLcdpStore.lcdpId = id;
    (window as any).globalLcdpStore.env = env;
  } else {
    (window as any).globalLcdpStore = {
      lcdpId: id,
      env: env,
    };
  }
}

function removeLcdpId() {
  if (typeof (window as any).globalLcdpStore === 'object') {
    (window as any).globalLcdpStore.lcdpId = undefined;
    (window as any).globalLcdpStore.env = undefined;
  }
}

async function initConfig(
  props: RouteComponentProps<any> & {
    id: string;
    env: Env;
    language?: Language;
    containerDom?: Element;
    parserType?: 'lingo' | 'tangram';
  }
) {
  const { id, env, language, containerDom, parserType, ...restProps } = props;
  // 初始化前置必须的值
  await initComponents(parserType);

  const parser = parserType === 'tangram' ? tangramParser : getLingoParser();
  // 测试使用parser来源
  console.log('parser来源', parserType, parser);

  const data = await parser.initPage({
    pageId: id,
    env,
    language,
  });
  const routerContext = { ...restProps };
  containerDom && parser.initLCPStore(data, containerDom, { routerContext });
}

export interface LcdpComponentProps {
  id: string;
  env: Env;
  className?: string;
  React?: typeof _React;
  ReactRouterDom?: typeof _ReactRouterDom;
  style?: React.CSSProperties;
}

export const Lcdp: FC<RouteComponentProps<any> & LcdpComponentProps> = props => {
  const { React = _React } = props;
  const id = lcdpMapping?.[props.id] || props.id;
  const lcdpContainerRef = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (lcdpContainerRef.current) {
      initConfig({ ...props, id, containerDom: lcdpContainerRef.current });
      setLcdpId(id, props.env);
    }
  }, [id, lcdpContainerRef.current]);

  React.useEffect(() => {
    return () => {
      removeLcdpId();
      try {
        const containerDom = document.getElementById(id);
        containerDom && window['ReactDOM'].unmountComponentAtNode(containerDom);
        console.log('当前的容器：', containerDom);
        /** 在多次卸载后，lcdpContainerRef?.current 会取不到值 */
        // lcdpContainerRef?.current &&
        //   window['ReactDOM'].unmountComponentAtNode(lcdpContainerRef?.current);
      } catch (error) {
        console.log('unmountComponentAtNode error', error);
      }
    };
  }, []);

  return (
    <div className={props.className} style={props.style} ref={lcdpContainerRef} id={id}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: 50,
          height: 50,
          margin: 'auto',
        }}
      >
        <Loading />
      </div>
    </div>
  );
};

export const LcdpComponent: FC<LcdpComponentProps> = props => {
  const { React = _React, ReactRouterDom = _ReactRouterDom } = props;
  const LcdpComponentRouter = React.useMemo(
    () => ReactRouterDom.withRouter(Lcdp),
    [ReactRouterDom]
  );
  return React.createElement(LcdpComponentRouter, props);
};

export default LcdpComponent;
